// extracted by mini-css-extract-plugin
var _1 = "CommentInput-module__animateUploadProgressBarWidth--RfTQ0";
var _2 = "CommentInput-module__animatedBackground--vis3h";
var _3 = "CommentInput-module__container--g4Lj4";
var _4 = "CommentInput-module__content--ozHhk";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "content" }
